import type { Review } from '@homeviews/models'

const FIELDS = [
  'title',
  'content',
  'location_comments',
  'landlord_comments',
  'developer_comments',
  'one_thing',
  'one_change',
  'problem_response',
  'best_feature',
  'additions',
  'reason',
  'disclosure',
]

export const getExcerptIndexableData = (review: Partial<Review>) => {
  const data = []
  FIELDS.map((field) => {
    if (review[field]) {
      data.push(review[field])
    }
  })
  return data
}
